var postMessageTransporter;

EF.on('ready', function() {
  var isInIframe = window.self !== window.top;
  var isConsumer = $('iframe[data-pm-enabled]').length && !isInIframe;
  var isPmMode = EF && EF.options && EF.options.pmMode;
  
  if(isConsumer || isPmMode) {
    postMessageTransporter = {
      listeners: [],
      addListener: function(listener) {
        this.listeners.push(listener);
      },
      onMessage: function(event) {
        var message = event.data;
        try {
          message = JSON.parse(message);
        } catch(e) {
          //noop
        }

        for(var i = 0; i < this.listeners.length; i++) {
          this.listeners[i](message, event.origin);
        }
      },

      postMessage: function(message) {
        window.parent.postMessage(JSON.stringify(message), EF.config.get('basePath'));
      }
    };

    if(window.addEventListener) {
      window.addEventListener('message', postMessageTransporter.onMessage.bind(postMessageTransporter), false);
    } else {
      window.attachEvent('message', postMessageTransporter.onMessage.bind(postMessageTransporter));
    }
  } else if(isInIframe && EF) {
    postMessageTransporter = {
      postMessage: function(message) {
        if(EF && EF.config) {
          window.parent.postMessage(JSON.stringify(message), EF.config.get('basePath'));
        }
      }
    };
  }

  if(isPmMode) {
    EF.listen(EF.receiveMessage);
  }
});
